import { Button } from "@mui/material";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";

type TExpandTextProps = {
  message: string;
};

function ExpandText(props: TExpandTextProps) {
  const { message } = props;
  const [shouldExpand, setShouldExpand] = useState(false);
  const { t } = useTranslation();
  if (message.length < 30 || shouldExpand) {
    return <div>{message}</div>;
  } else {
    return (
      <Button variant="contained" onClick={() => setShouldExpand(true)}>
        {t("Άνοιγμα Μηνύματος:")}
      </Button>
    );
  }
}

export default ExpandText;
